<app-auth-card
  [loader]="loginComponentLoader"
  [title]="'auth.login.login' | translate"
  [description]="'auth.login.loginDescription' | translate"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 gap-4">
    <div>
      <label
        [appRequiredLabel]="editForm.controls.email"
        for="email"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.login.email' | translate }}</label
      >
      <input
        pInputText
        id="email"
        type="email"
        autocomplete="username"
        [placeholder]="'auth.login.email' | translate"
        class="w-full"
        formControlName="email"
      />
      <app-form-error [control]="editForm.controls.email" />
    </div>

    <div>
      <label
        [appRequiredLabel]="editForm.controls.password"
        for="password"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.login.password' | translate }}</label
      >
      <p-password
        inputId="password"
        formControlName="password"
        autocomplete="current-password"
        [placeholder]="'auth.login.password' | translate"
        [toggleMask]="true"
        [fluid]="true"
        [feedback]="false"
      />
      <app-form-error [control]="editForm.controls.password" />
    </div>

    @if (twoFactorEnabled() && editForm.controls.twoFactorCode) {
      <div>
        <label
          [appRequiredLabel]="editForm.controls.twoFactorCode"
          for="twoFactorCode"
          class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
          >{{ 'auth.login.twoFactorCode' | translate }}</label
        >
        <p-password
          inputId="twoFactorCode"
          formControlName="twoFactorCode"
          autocomplete="one-time-code"
          [placeholder]="'auth.login.twoFactorCode' | translate"
          [toggleMask]="true"
          [fluid]="true"
          [feedback]="false"
        />
        <app-form-error [control]="editForm.controls.twoFactorCode" />
      </div>
      <div class="flex items-center justify-center">
        <p-button
          variant="text"
          (onClick)="onSubmit(true)"
          label="{{ secondsLeft() ? secondsLeft() + 's ' : '' }}{{ 'auth.login.generateNewTwoFactorCode' | translate }}"
          [disabled]="secondsLeft() > 0"
          [loading]="secondsLeft() > 0"
        />
      </div>
    }

    <div class="flex justify-end">
      <a [routerLink]="['/auth/forgot-password']" class="text-primary font-medium no-underline hover:underline">
        {{ 'auth.login.forgotPassword' | translate }}?
      </a>
    </div>

    <p-button
      type="submit"
      [label]="'auth.login.submit' | translate"
      icon="pi pi-sign-in"
      size="large"
      styleClass="w-full"
    />
  </form>

  <div class="mt-6 text-center">
    <a [routerLink]="['/auth/register']" class="text-primary font-medium no-underline hover:underline">
      {{ 'auth.login.register' | translate }}
    </a>
  </div>
</app-auth-card>
